
import {
  computed,
  defineComponent,
  onBeforeMount,
  onMounted,
  ref,
  toRaw,
  watch,
} from "vue";
import { getIllustrationsPath } from "@/core/helpers/assets";
import { GoogleMap, Marker, InfoWindow } from "vue3-google-map";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";

export default defineComponent({
  name: "ReportReadyCtms",
  components: {
    GoogleMap,
    Marker,
    InfoWindow,
  },
  props: {
    vtbtab: Boolean,
    ctmstab: Boolean,
    widgetClasses: String,
    consent_status: String,
  },

  setup() {
    const store = useStore();
    const clickcheck = ref(false);
    const ctmsreport = ref();
    const file_name = ref("");
    let expand_trial = ref(false) as any;
    let patient_values = [] as any;
    let pv_longtext_raw = [] as any;
    let marker_positions3 = ref([]) as any;
    let marker_positions = ref([]) as any;
    const mapRef = ref(null) as any;
    const fileref = ref();
    const center = ref({ lat: 39.87355222614361, lng: -100.87624332851627 });

    let widget_results1 = ref([]) as any;

    onBeforeMount(() => {
      store.dispatch(Actions.GET_PATIENT_REPORT, { req_type: "ctms_summary" });
    });

    onMounted(() => {
      watch(
        () => mapRef.value.ready,
        (ready) => {
          if (ready) {
            watch(
              () => store.getters.getPatientReport,
              function (sd) {
                widget_results1.value = JSON.parse(JSON.stringify(toRaw(sd)));
                pv_longtext_raw = Object.values(toRaw(sd));

                center.value = store.getters.getPatientCTMSMapCenter;

                for (var i = 0; i < pv_longtext_raw.length; i++) {
                  if (pv_longtext_raw[i].lat) {
                    marker_positions3.value.push({
                      position: {
                        lat: parseFloat(pv_longtext_raw[i].lat),
                        lng: parseFloat(pv_longtext_raw[i].lng),
                      },
                      infowindow: pv_longtext_raw[i],
                    });
                  }
                }
              }
            );
          }
        }
      );
    });
    if (!widget_results1.value) {
      store.dispatch(Actions.GET_PATIENT_REPORT, { req_type: "ctms_summary" });
    }

    watch(
      () => store.getters.getPatientReportFileName,
      function (fn) {
        console.log(fn);
        file_name.value = fn;
      }
    );

    watch(
      () => mapRef.value,
      function (r) {
        if (r) {
          console.log("test5");
        }
      }
    );

    return {
      file_name,
      mapRef,
      patient_values,
      marker_positions3,
      center,
      getIllustrationsPath,
      getCtrialValues: (t) => {
        store.dispatch(Actions.GET_CTRIAL_VALUES, { trialid: t });
        expand_trial.value = "ok";
      },

      HideThis: (t) => {
        expand_trial.value = false;
      },
      trial_data: computed(() => store.getters.getCtrialValues),
      get_file: (t) => {
        if (!clickcheck.value) {
          store.dispatch(Actions.GET_PATIENT_REPORT_BLOB, {
            req_type: "ctms_download",
          });
          clickcheck.value = true;
          watch(
            () => store.getters.getPatientReportBlob,
            function (r) {
              if (r) {
                let link = document.createElement("a");
                link.href = "data:application/pdf;base64," + r;
                link.download = t;
                link.click();
              }
            }
          );
        } else {
          const apimodule = toRaw(store.state.ApiModule);
          let link = document.createElement("a");
          link.href =
            "data:application/pdf;base64," + apimodule.patient_report_blob;
          link.download = t;
          link.click();
        }
      },
      widget_results1,
      expand_trial,
    };
  },
});
